import { buildAxonItem, pushAxonEvent } from '@/utils/axonTrack'

export function useAxonViewItem() {
  const reportedMethods = new Set<number>()

  function reportViewItem(
    products: any[],
    currentPaymentMethod: number,
    itemName: 'Coins Package' | 'Membership',
    getPrice: (p: any) => string | number = p => p.price,
    // contentId 为书籍 id,阅读页付费墙场景传入,store 场景无书为空
    contentId?: string | number,
  ) {
    if (!products.length)
      return
    if (reportedMethods.has(currentPaymentMethod))
      return

    reportedMethods.add(currentPaymentMethod)
    pushAxonEvent('view_item', {
      currency: 'USD',
      items: products.map(p => buildAxonItem(p.productId, contentId, itemName, getPrice(p))),
    })
  }

  return { reportViewItem }
}
